export default {"src":"/_next/static/media/card.27f874b2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};